import styled from 'styled-components';

import {
  MonthSelectorLeftArrow,
  MonthSelectorRightArrow,
  DayPickerContainer
} from '@spa/shared/components/MoveInOutPicker/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(3)};

  ${DayPickerContainer} {
    box-shadow: none;
    padding: 0;
  }

  ${MonthSelectorLeftArrow},
  ${MonthSelectorRightArrow} {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${props => props.theme.unisystem.calendar.arrowButtonsBackground};
    box-shadow: 0px 3px 10px 0px rgba(34, 66, 81, 0.1);

    svg {
      width: 14px;
      height: 14px;
    }
  }

  ${MonthSelectorLeftArrow},
  ${MonthSelectorRightArrow} {
    border: none;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.space(2)};
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(3)};
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${props => props.theme.space(3)};
`;

export const DatesTitle = styled.p`
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.unisystem.calendar.datesLabel.titleColor};
  display: flex;
  align-items: center;
  ${({ theme }) => theme.gap(2)};
  height: 26px;

  svg {
    width: 24px;
    height: 24px;
  }

  span {
    background-color: ${props => props.theme.unisystem.calendar.datesLabel.selectMoveInOut.background};
    font-size: ${props => props.theme.rem(14)};
    line-height: ${props => props.theme.rem(18)};
    color: ${props => props.theme.unisystem.calendar.datesLabel.selectMoveInOut.color};
    padding: ${props => props.theme.space(1)} ${props => props.theme.space(2)};
    border-radius: 4px;
  }
`;
